import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { ContentTitle, EntityGrid, PostDetailsLayout, useLang, usePosts } from '@shapeable/ui';
import { YELLOW } from '../../theme';
import { sortBy, reverse } from 'lodash';

// -------- Child Component Props -------->

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    font-size: 1em;
  `,
});

const MainTitleStyles = breakpoints({
    base: css`
      margin-bottom: ${theme.UNIT(4)};
      color: ${theme.COLOR('mid')};
      text-transform: uppercase;
      font-weight: 400;
    `,
});

const RelatedContentStyles = breakpoints({
    base: css`
        padding: ${theme.UNIT(6)} ${theme.UNIT(0)} ${theme.UNIT(7)};
        ${theme.H_DOT_BG_END()};
        margin-bottom: ${theme.UNIT(4)};
    `,
});

// -------- Components -------->

const My = {
  Container: styled(PostDetailsLayout)`${ContainerStyles}`,
    MainTitle: styled.span`${MainTitleStyles}`,
    RelatedContent: styled(EntityGrid)`${RelatedContentStyles}`,
};

export const PostLayout: PageLayoutComponent = (props) => {
  const { className, entity } = props;

  const t = useLang();
  const posts = usePosts().filter(post => post.id !== entity.id);

  const relatedContent = sortBy(
    [ ...posts ],
    (item) => item.published ? new Date(item.published).getTime() : 0,
  ).reverse();

  const hasRelatedContent = !!relatedContent.length;

  if (!entity) {
    return null;
  }
  
  return (
    <My.Container 
      className={className} 
      entity={entity}
      headerProps={{
        backgroundColor: YELLOW,
      }}
      bannerDetailsProps={{
        aspectRatio: { 
          base: 16 / 9, 
          tablet: 16 / 9,
          desktop: 16 / 9,
        },
        colors: {
          text: 'strong',
          stroke: 'strong',
          border: 'strong',
          fill: 'strong',
          hover: {
            text: 'strong',
            border: 'button-hover',
            stroke: 'button-hover',
            fill: 'button-hover',
          }
        }
      }}
      main={
        <>
          {hasRelatedContent && (
            <>
              <My.MainTitle>{t('Related Content:')}</My.MainTitle>
              <My.RelatedContent spacing={2} maxColumns={3} items={relatedContent.slice(0,3)} />
            </>
          )}
        </>
      }
    />
  )
};
